import api from '../lib/api';
import { toArray } from '../lib/utils';
import type { CompanyQrcode, QrcodeCoupon, QrcodeFilters, QrcodeResponse } from '../types/qrcode';

class QrcodeService {
  // QR Codes
  async getQrcodes(filters: QrcodeFilters = {}): Promise<QrcodeResponse> {
    const response = await api.get('/ace/qrcodes', { params: filters });
    return response.data;
  }

  async getQrcode(id: number): Promise<CompanyQrcode> {
    const response = await api.get(`/ace/qrcodes/${id}`);
    return response.data;
  }

  async createQrcode(data: Partial<CompanyQrcode>): Promise<CompanyQrcode> {
    const response = await api.post('/ace/qrcodes', data);
    return response.data;
  }

  async updateQrcode(id: number, data: Partial<CompanyQrcode>): Promise<CompanyQrcode> {
    const response = await api.put(`/ace/qrcodes/${id}`, data);
    return response.data;
  }

  async deleteQrcode(id: number): Promise<void> {
    await api.delete(`/ace/qrcodes/${id}`);
  }

  // QR Code Coupons
  async getQrcodeCoupons(qrcodeId?: number): Promise<QrcodeCoupon[]> {
    const params = qrcodeId ? { company_qrcode_id: qrcodeId } : undefined;
    const response = await api.get('/ace/qrcodes/coupons', { params });
    return toArray(response.data);
  }

  async getQrcodeCoupon(id: number): Promise<QrcodeCoupon> {
    const response = await api.get(`/ace/qrcodes/coupons/${id}`);
    return response.data;
  }

  async createQrcodeCoupon(data: Partial<QrcodeCoupon>): Promise<QrcodeCoupon> {
    const response = await api.post('/ace/qrcodes/coupons', data);
    return response.data;
  }

  async updateQrcodeCoupon(id: number, data: Partial<QrcodeCoupon>): Promise<QrcodeCoupon> {
    const response = await api.put(`/ace/qrcodes/coupons/${id}`, data);
    return response.data;
  }

  async deleteQrcodeCoupon(id: number): Promise<void> {
    await api.delete(`/ace/qrcodes/coupons/${id}`);
  }

  // Get promotion companies for dropdown
  async getPromotionCompanies(): Promise<any[]> {
    const response = await api.get('/ace/promotion-companies');
    return toArray(response.data);
  }
}

export default new QrcodeService();
